<template>
  <header class="site-header">
    <div class="header-container">
      <!-- 左侧logo和文字 -->
      <div class="header-left">
        <img src="../assets/logo.png" alt="logo" class="header-logo" />
        <img src="../assets/biaoti.png" alt="重庆市兰台档案研究院" class="header-titles" />
      </div>
      <!-- 移动端菜单按钮 -->
      <button class="mobile-menu-btn" @click="mobileMenuOpen = !mobileMenuOpen">
        <span class="menu-icon">☰</span>
      </button>
      <!-- 中间菜单 -->
      <nav :class="['header-nav', { 'mobile-open': mobileMenuOpen }]">
        <template v-if="!isInPersonalCenter">
          <router-link to="/" class="header-nav-item" exact @click.native="mobileMenuOpen = false">首页</router-link>
          <router-link to="/mall" class="header-nav-item" @click.native="mobileMenuOpen = false">商城</router-link>
          <router-link to="/institute" class="header-nav-item" @click.native="mobileMenuOpen = false">研究院</router-link>
          <router-link to="/news" class="header-nav-item" @click.native="mobileMenuOpen = false">新闻动态</router-link>
          <router-link to="/project" class="header-nav-item" @click.native="mobileMenuOpen = false">项目研究</router-link>
          <router-link to="/volume" class="header-nav-item" @click.native="mobileMenuOpen = false">兰台研读</router-link>
          <router-link to="/policy" class="header-nav-item" @click.native="mobileMenuOpen = false">政策法规</router-link>
          <router-link to="/talent" class="header-nav-item" @click.native="mobileMenuOpen = false">人才招聘</router-link>
          <router-link v-if="isLoggedIn" to="/profile" class="header-nav-item" @click.native="mobileMenuOpen = false">个人资料</router-link>
        </template>
        <template v-else>
          <router-link to="/" class="header-nav-item" exact @click.native="mobileMenuOpen = false">首页</router-link>
          <router-link to="/archive-course" class="header-nav-item" @click.native="mobileMenuOpen = false">档案课程</router-link>
          <router-link to="/purchased-course" class="header-nav-item" @click.native="mobileMenuOpen = false">已购课程</router-link>
          <router-link to="/grade-query" class="header-nav-item" @click.native="mobileMenuOpen = false">成绩查询</router-link>
          <router-link to="/e-certificate" class="header-nav-item" @click.native="mobileMenuOpen = false">电子证书</router-link>
          <router-link v-if="isLoggedIn" to="/profile" class="header-nav-item" @click.native="mobileMenuOpen = false">个人资料</router-link>
        </template>
        <!-- 移动端显示的登录和证书查询按钮 -->
        <div class="mobile-extra">
          <template v-if="isLoggedIn">
            <div class="user-info-mobile">
              <div>{{ userInfo ? userInfo.name : '加载中...' }}</div>
              <span class="logout-text-mobile" @click="handleLogout">退出登录</span>
            </div>
          </template>
          <button v-else class="login-btn-mobile" @click="showAuthDialog('login'); mobileMenuOpen = false">登 录</button>
          <button class="cert-query-btn-mobile" @click="showCertificateDialog">证书查询</button>
        </div>
      </nav>
      <!-- 右侧按钮区域 -->
      <div class="header-right">
        <template v-if="isLoggedIn">
          <div class="user-info">
            <div class="welcome-text">
              <span class="user-name-display">{{ userInfo ? userInfo.name : '加载中...' }}</span>
            </div>
            <div class="user-actions">
              <span class="logout-text" @click="handleLogout">退出登录</span>
            </div>
          </div>
        </template>
        <button v-else class="login-btn" @click="showAuthDialog('login')">登 录</button>
        <button class="cert-query-btn" @click="showCertificateDialog">
          <svg class="cert-icon-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2"/>
            <line x1="16.5" y1="16.5" x2="21" y2="21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          证书查询
        </button>
      </div>
    </div>
    <auth-dialog :visible.sync="authDialogVisible" :initial-mode="authMode" @login-success="handleLoginSuccess" />
    
    <!-- 证书查询弹窗 -->
    <el-dialog 
      title="查询证书" 
      :visible.sync="certificateDialogVisible" 
      width="90%"
      :close-on-click-modal="false"
      custom-class="certificate-dialog"
      @close="handleCloseDialog"
    >
      <!-- 查询表单 -->
      <el-form :model="searchForm" label-width="100px" class="search-form">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="手机号">
              <el-input v-model="searchForm.phone" placeholder="请输入手机号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号">
              <el-input v-model="searchForm.idCard" placeholder="请输入身份证号" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名">
              <el-input v-model="searchForm.name" placeholder="请输入姓名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书编号">
              <el-input v-model="searchForm.certificateNumber" placeholder="请输入证书编号" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="证书类型">
              <el-input v-model="searchForm.type" placeholder="请输入证书类型" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: center;">
            <el-button type="primary" @click="handleSearch" :loading="searchLoading">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>

      <!-- 查询结果 -->
      <div v-if="certificateList.length > 0" class="result-section">
        <el-divider content-position="left">查询结果（共 {{ totalCount }} 条）</el-divider>
        <el-table 
          :data="certificateList" 
          border 
          style="width: 100%"
          max-height="400"
        >
          <el-table-column prop="name" label="姓名" width="120"></el-table-column>
          <el-table-column prop="phone" label="手机号" width="130"></el-table-column>
          <el-table-column prop="idCard" label="身份证号" width="180"></el-table-column>
          <el-table-column prop="certificateNumber" label="证书编号" width="180"></el-table-column>
          <el-table-column label="证书类型" width="120">
            <template slot-scope="scope">
              {{ certificateTypeMap[scope.row.type] || scope.row.type || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="课程方向" width="150">
            <template slot-scope="scope">
              {{ courseDirectionMap[scope.row.courseDirection] || scope.row.courseDirection || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
          <el-table-column label="证书图片" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button 
                type="text" 
                size="small" 
                @click="viewCertificate(scope.row)"
                v-if="scope.row.certificateUrl"
              >
                查看
              </el-button>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 没有查询结果 -->
      <div v-else-if="hasSearched && !searchLoading" class="no-result">
        <el-empty description="未查询到相关证书信息"></el-empty>
      </div>
    </el-dialog>

  </header>
</template>

<script>
import AuthDialog from './AuthDialog.vue'
import { getCertificateOtherImgWx } from '../api/website'

export default {
  name: 'SiteHeader',
  components: {
    AuthDialog
  },
  data() {
    return {
      authDialogVisible: false,
      authMode: 'login', // 'login' or 'register'
      mobileMenuOpen: false, // 移动端菜单开关
      // 证书查询相关
      certificateDialogVisible: false,
      searchForm: {
        phone: '',
        idCard: '',
        name: '',
        certificateNumber: '',
        type: ''
      },
      certificateList: [],
      totalCount: 0,
      searchLoading: false,
      hasSearched: false,
      // 课程方向映射
      courseDirectionMap: {
        '1': '默认',
        '2': '监控',
        '3': '维保',
        '4': '三级',
        '5': '四级',
        '6': '五级'
      },
      // 证书类型映射
      certificateTypeMap: {
        '1': '结业'
      }
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.isLoggedIn
    },
    userInfo() {
      return this.$store.state.userInfo
    },
    isInPersonalCenter() {
      return this.$store.state.isInPersonalCenter
    }
  },
  created() {
    // 如果已登录但没有用户信息，则获取用户信息
    if (this.isLoggedIn && !this.userInfo) {
      this.$store.dispatch('fetchUserInfo')
    }
  },
  methods: {
    showAuthDialog(mode) {
      if (!this.isLoggedIn || mode === 'register') {
        this.authMode = mode
        this.authDialogVisible = true
      }
    },
    handleLoginSuccess() {
      // 登录状态已经在 Vuex 中更新，不需要额外处理
    },
    async handleLogout() {
      try {
        await this.$confirm('确认退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        this.$store.dispatch('logout')
        this.$router.push('/')
        this.$message.success('已退出登录')
      } catch (error) {
        // 用户取消退出
      }
    },
    togglePersonalCenter() {
      this.$store.dispatch('setPersonalCenterMode', !this.isInPersonalCenter)
      if (!this.isInPersonalCenter) {
        this.$router.push('/')
      }
    },
    // 证书查询相关方法
    showCertificateDialog() {
      this.certificateDialogVisible = true
      this.mobileMenuOpen = false
    },
    handleCloseDialog() {
      this.handleReset()
    },
    async handleSearch() {
      // 检查是否至少填写了一个查询条件
      const hasCondition = Object.values(this.searchForm).some(value => value && value.trim())
      if (!hasCondition) {
        this.$message.warning('请至少填写一个查询条件')
        return
      }

      this.searchLoading = true
      this.hasSearched = false
      
      try {
        // 构建查询参数（只传有值的参数）
        const params = {}
        Object.keys(this.searchForm).forEach(key => {
          if (this.searchForm[key] && this.searchForm[key].trim()) {
            params[key] = this.searchForm[key].trim()
          }
        })

        const response = await getCertificateOtherImgWx(params)
        
        if (response.code === 0 || response.code === 200) {
          this.certificateList = response.rows || []
          this.totalCount = response.total || 0
          this.hasSearched = true
          
          if (this.certificateList.length === 0) {
            this.$message.info('未查询到相关证书信息')
          } else {
            this.$message.success(`查询成功，共找到 ${this.totalCount} 条记录`)
          }
        } else {
          this.$message.error(response.msg || '查询失败')
          this.certificateList = []
          this.totalCount = 0
          this.hasSearched = true
        }
      } catch (error) {
        console.error('查询证书失败:', error)
        this.$message.error('查询失败，请稍后重试')
        this.certificateList = []
        this.totalCount = 0
        this.hasSearched = true
      } finally {
        this.searchLoading = false
      }
    },
    handleReset() {
      this.searchForm = {
        phone: '',
        idCard: '',
        name: '',
        certificateNumber: '',
        type: ''
      }
      this.certificateList = []
      this.totalCount = 0
      this.hasSearched = false
    },
    viewCertificate(row) {
      if (row.certificateUrl) {
        // 直接在新窗口打开证书文件（支持PDF和图片）
        window.open(row.certificateUrl, '_blank')
      }
    }
  }
}
</script>

<style scoped>
.site-header {
  background: transparent;
  color: #333;
  border-radius: 0;
  padding: 0;
  box-shadow: none;
}

.header-container {
  background: #fdf3ea;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  width: 79.17%;
  max-width: 1520px;
  margin: 0 auto;
  padding: 0 27px;
  box-sizing: border-box;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.header-logo {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: contain;
}

.header-titles {
  height: 50px;
  object-fit: contain;
  margin-left: 4px;
}

.header-nav {
  display: flex;
  flex: 1;
  justify-content: center;
  gap: 4px;
  margin: 0 20px;
}

.header-nav-item {
  color: #ecb68a;
  font-size: 14px;
  text-decoration: none;
  padding: 8px 12px;
  transition: all 0.2s;
  font-weight: 400;
  white-space: nowrap;
  border-radius: 0;
  position: relative;
}

.header-nav-item:hover {
  color: #ad634a;
}

.header-nav-item.router-link-active {
  color: #ad634a;
  font-weight: 600;
}

.header-nav-item.router-link-active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  height: 2px;
  background: #ad634a;
  border-radius: 1px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.login-btn {
  background: #eab58b;
  color: #fff;
  border: 1px solid #eab58b;
  border-radius: 20px;
  padding: 6px 24px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  letter-spacing: 4px;
}

.login-btn:hover {
  background: #ad634a;
  color: #fff;
}

.cert-query-btn {
  background: #D32F2F;
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 7px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
}

.cert-query-btn:hover {
  background: #B71C1C;
}

.cert-icon-svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.user-info {
  display: flex;
  flex-direction: column;
  color: #ecb68a;
}

.user-name-display {
  font-weight: 600;
  color: #ad634a;
}

.welcome-text {
  font-size: 14px;
  line-height: 1.2;
  white-space: nowrap;
}

.logout-text {
  font-size: 12px;
  color: #999;
  text-decoration: underline;
  cursor: pointer;
  line-height: 1.2;
  text-align: right;
}

.logout-text:hover {
  color: #ad634a;
}

.user-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 2px;
}

/* 移动端适配 */
.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  color: #ad634a;
  font-size: 28px;
  cursor: pointer;
  padding: 5px 10px;
}

.mobile-extra {
  display: none;
}

@media screen and (max-width: 768px) {
  .site-header {
    border-radius: 0;
    position: sticky;
    top: 0;
    z-index: 1002;
    background: #fdf3ea;
    box-shadow: 0 1px 8px rgba(139, 69, 19, 0.08);
  }

  .header-container {
    height: 56px;
    margin: 0;
    padding: 0 14px 0 12px;
    position: relative;
    max-width: 100%;
    width: 100%;
  }

  .header-left {
    flex: 1;
    gap: 8px;
    min-width: 0;
  }

  .header-logo {
    width: 38px;
    height: 38px;
    flex-shrink: 0;
  }

  .header-titles {
    height: 34px;
    max-width: calc(100vw - 100px);
    width: auto;
    object-fit: contain;
    object-position: left center;
  }

  .mobile-menu-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1001;
    width: 44px;
    height: 44px;
    padding: 0;
    font-size: 24px;
    color: #ad634a;
    flex-shrink: 0;
  }

  .header-nav {
    position: fixed;
    top: 56px;
    left: -100%;
    width: 100%;
    height: calc(100vh - 56px);
    background: #fdf3ea;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    gap: 0;
    margin: 0;
    padding: 8px 0 24px;
    transition: left 0.3s ease;
    z-index: 1000;
    overflow-y: auto;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  }

  .header-nav.mobile-open {
    left: 0;
  }

  .header-nav-item {
    padding: 16px 22px;
    border-bottom: 1px solid rgba(173, 99, 74, 0.08);
    font-size: 16px;
    border-radius: 0;
    color: #8b5a45;
  }

  .header-nav-item.router-link-active::after {
    display: none;
  }

  .header-nav-item.router-link-active,
  .header-nav-item:hover {
    background: rgba(173, 99, 74, 0.1);
    color: #ad634a;
  }

  .header-right {
    display: none;
  }

  .mobile-extra {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 20px 22px;
    margin-top: 8px;
    border-top: 1px solid rgba(173, 99, 74, 0.12);
  }

  .user-info-mobile {
    display: flex;
    flex-direction: column;
    gap: 10px;
    color: #ad634a;
    padding: 10px 0;
    font-weight: 500;
  }

  .logout-text-mobile {
    color: #999;
    text-decoration: underline;
    cursor: pointer;
    font-size: 14px;
  }

  .login-btn-mobile {
    background: #ad634a;
    color: #fff;
    border: none;
    border-radius: 22px;
    padding: 13px 24px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    letter-spacing: 4px;
  }

  .login-btn-mobile:hover {
    background: #8b4513;
  }

  .cert-query-btn-mobile {
    background: #fff;
    color: #ad634a;
    border: 1px solid #ad634a;
    border-radius: 22px;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s;
  }

  .cert-query-btn-mobile:hover {
    background: #fdf3ea;
  }
}

/* 证书查询弹窗样式 */
.search-form {
  margin-bottom: 20px;
}

.result-section {
  margin-top: 30px;
}

.no-result {
  margin-top: 30px;
  padding: 40px 0;
  text-align: center;
}
</style>

<style>
/* 全局样式 - 证书弹窗 */
.certificate-dialog {
  max-width: 900px;
}

.certificate-dialog .el-dialog__body {
  max-height: 70vh;
  overflow-y: auto;
}

@media screen and (max-width: 768px) {
  .certificate-dialog {
    width: 95% !important;
  }
  
  .certificate-dialog .el-form-item {
    margin-bottom: 15px;
  }
  
  .certificate-dialog .el-table {
    font-size: 12px;
  }
}
</style>